import { inject, observer } from 'mobx-react';
import * as React from 'react';
import JsxRenderer from '../util/JsxRenderer';
const HtmlContent = (props) => {
    const { field, propStateStore: { env } } = props;
    return React.createElement(JsxRenderer, { jsx: field.content, env: env, showErrorNotice: false, doNotScroll: true });
};
export default inject('propStateStore')(observer(HtmlContent));
//# sourceMappingURL=HtmlContent.js.map